import { useState } from "react";
import { Card, Space, Typography } from "antd";
import { PlugsConnectedIcon } from "@phosphor-icons/react";
import { useNotification, useTranslate } from "@refinedev/core";
import { Button } from "@libertify/ui";
import useGetTransferToken from "hooks/useGetTransferToken";
import { API_URL } from "@/constants";

const { Title, Paragraph } = Typography;

export const IntegrationsTab = () => {
  const t = useTranslate();
  const { open: notify } = useNotification();
  const [isConnecting, setIsConnecting] = useState(false);
  // enabled: false — only fetch a transfer token on demand (button click),
  // not on mount or on the hook's default auto-refresh interval.
  const { refetch: fetchTransferToken } = useGetTransferToken({
    enabled: false,
  });

  const handleConnect = async () => {
    setIsConnecting(true);
    try {
      const { data } = await fetchTransferToken();
      const token = data?.data.transfer_token;
      if (!token) {
        throw new Error("No transfer token returned");
      }
      // Hand off to the backend's HubSpot OAuth install flow
      globalThis.open(
        `${API_URL}/crm/hubspot/redirect?state=${encodeURIComponent(token)}`,
        "_blank",
        "noopener,noreferrer"
      );
    } catch (error) {
      console.error("Failed to start HubSpot connection", error);
      notify?.({
        type: "error",
        message: t("media.organizations.hubspot.errorMessage"),
      });
    } finally {
      setIsConnecting(false);
    }
  };

  return (
    <Card>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Title level={4} style={{ margin: 0 }}>
          {t("media.organizations.hubspot.title")}
        </Title>
        <Paragraph type="secondary" style={{ margin: 0 }}>
          {t("media.organizations.hubspot.description")}
        </Paragraph>
        <Button
          variant="primary"
          size="m"
          loading={isConnecting}
          leftIcon={<PlugsConnectedIcon />}
          onClick={() => {
            handleConnect().catch((error) => {
              console.error("Unexpected HubSpot connection error", error);
            });
          }}
        >
          {t("media.organizations.hubspot.connectButton")}
        </Button>
      </Space>
    </Card>
  );
};

export default IntegrationsTab;
